/* tslint:disable */
// @ts-nocheck
/* eslint-disable */
/**
 * Rana simulation API
 *
 * The version of the OpenAPI document: v3
 * Contact: info@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * * `pending` - pending
 * * `confirmed` - confirmed
 * * `timeout` - timeout
 * @export
 */
export const SimulationChannelStateEnum = {
  PENDING: "pending",
  CONFIRMED: "confirmed",
  TIMEOUT: "timeout",
} as const;
export type SimulationChannelStateEnum =
  (typeof SimulationChannelStateEnum)[keyof typeof SimulationChannelStateEnum];

export function instanceOfSimulationChannelStateEnum(value: any): boolean {
  for (const key in SimulationChannelStateEnum) {
    if (Object.prototype.hasOwnProperty.call(SimulationChannelStateEnum, key)) {
      if (SimulationChannelStateEnum[key as keyof typeof SimulationChannelStateEnum] === value) {
        return true;
      }
    }
  }
  return false;
}

export function SimulationChannelStateEnumFromJSON(json: any): SimulationChannelStateEnum {
  return SimulationChannelStateEnumFromJSONTyped(json, false);
}

export function SimulationChannelStateEnumFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): SimulationChannelStateEnum {
  return json as SimulationChannelStateEnum;
}

export function SimulationChannelStateEnumToJSON(value?: SimulationChannelStateEnum | null): any {
  return value as any;
}

export function SimulationChannelStateEnumToJSONTyped(
  value: any,
  ignoreDiscriminator: boolean
): SimulationChannelStateEnum {
  return value as SimulationChannelStateEnum;
}
